<template>
  <div class="index">
	<Heads ></Heads>
    <div>
      <router-view></router-view>
    </div>
	<Foot></Foot>
  </div>
</template>
<script>
import Heads from '../../components/Heads/Index'
import Foot from '../../components/Foot/Index'
export default {
  name: "index",
  components: {
	 Heads,Foot
  }
};
</script>
<style lang="scss" scoped>
#loginWrap{
	display: none;
}
	.pop_bg{
	width: 100%;
    left: 0px;
    top: 0px;
    height: 100%;
    position: fixed;
/*    user-select: none; */
    z-index: 999999;
	background-color: #000;
    opacity: .5;
}
.tsPop{
	position: fixed;
	background-color: #CF5D4F;
	position: absolute; 
	left: 50%;
	top: 50%;
	 z-index: 9999999;
	transform: translate(-50%, -50%);    /* 50%为自身尺寸的一半 */
	border-radius: 5px;
	width: 260px;
	height: 60px;
	color: #FFF;
	font-size: 14px;
	line-height: 60px;
	text-align: center;
}
.loginPop{
	position: fixed;
	background-color: #FFFFFF;
    position: absolute; 
	left: 50%;
	top: 50%;
	 z-index: 9999999;
    transform: translate(-50%, -50%);    /* 50%为自身尺寸的一半 */
	border-radius: 5px;
	
}
.popWrap{
	box-sizing: border-box;
	position: relative;
	padding: 14px 45px 0;
	width: 350px;
	height: 480px;
}
.popTab{
	border-bottom: 1px solid #E1E1E2;
}
.popTab ul li{
	 float: left;
	 padding: 12px 0;
	 width: 50%;
	 text-align: center;
	 height: 12px;
    line-height: 12px;
}
.popTab ul li a{
	font-size: 12px;
	color: #929193;
	position: relative;
}
.popTab ul .avt a{
	color:#178aff;
}
.popTab ul .avt a:after{
	content: '';
	position: absolute;
	background-color: #178AFF;
	height: 2px;
	width: 100%;
	bottom:-9px;
	left: 0;
	}
.popCode{
	border: 1px solid #e1e1e2;
	width: 260px;
	height: 260px;
	box-sizing: border-box;
	padding: 15px 11px 13px 14px;
	margin-top: 46px;
}	
.popCode img{
	width: 235px;
	height: 232px;
}
.popTs{
	margin-top: 38px;
	text-align: center;
}
.popBox .layui-form{
	margin-top: 32px;
}
.popBox .login-btn{
	padding-top: 20px;
}
.popBox .layui-btn{
	width: 100%;
	background-color: #178AFF;
}
.popBox .layui-input-inline{
	width: 100%;
	margin-bottom: 10px;
	position: relative;
}
.popBox .paswordPop{
	position: relative;
}
.popBox .paswordPop .noPwd{
	position: absolute;
	right: 14px;
	font-size: 12px;
	height: 12px;
	line-height: 12px;
	color: #777777;
	top: 14px;
	cursor: pointer;
	z-index: 99;
}
.popBox .paswordPop input{
	padding-right: 100px;
}
.popBox .layui-input-inline input{
	border:1px solid #E1E1E2 ;
	padding-left: 16px;
}
.popBox .layui-input-inline button{
	height: 40px;
	line-height: 40px;
	border: 0;
	border-radius: 3px;
	color: #FFFFFF;
}
.popBox .layui-input-inline input,.popBox .layui-form .layui-btn {
	height: 40px;
	line-height: 40px;
	width: 100%;
    box-sizing: border-box;
	border-radius: 3px;
}
.popBox .layui-form .layui-btn{
	border: 0;
	color: #FFFFFF;
}
.popBox .layui-input-inline .codes,.popBox .layui-input-inline .btnCode{
	width: 125px;
	box-sizing: border-box;
}
.popBox .layui-input-inline .codes{
	border:1px solid #E1E1E2 ;
}
.loginPop .icon{
	position: absolute;
	right: 9px;
	top: 14px;
	cursor: pointer;
}
.loginPop .icon img{
	width: 10px;
	height: 10px;
}
.popBox .layui-input-inline .btnCode{
	margin-left: 10px;
	background-color: #178AFF;
	color: #fff;
	border: 0;
	height: 40px;
	line-height: 40px;
	cursor: pointer;
	border-radius:5px ;
	padding-left: 0 !important;
}
.popWrap .linkPop{
	position: absolute;
	bottom: 30px;
	text-align: center;
	width: 100%;
	height: 14px;
	line-height: 14px;
	left: 0;
}
 .linkPop a{
	color: #333333;
	font-size: 14px;
	cursor: pointer;
 }
.tips{
	margin-top: 21px;
}
.tips p{
	font-size: 14px;
	color: #333333;
	text-align: center;
}
.popError{
	position: absolute;
	right: 0;
	top: -1px;
}
.popError .err{
	width: 12px;
    border: 1px solid #cf5d4f;
    height: 12px;
    text-align: center;
    box-sizing: border-box;
    line-height: 7px;
    border-radius: 50%;
	float: right;
}
.popError span{
	float: right;
	color: #cf5d4f;
	font-size: 12px;
	margin-left: 7px;
	line-height: 12px;
}

.popError .err img{
	width: 7px;
}
.popBox .upPhone .layui-btn{
	background-color: #FFFFFF;
	box-sizing: border-box;
	border:1px solid #178AFF;
	color: #333333;
}
</style>
